 
import { Entity } from './entity';
import { City } from './city';

export class Department extends Entity {
    public id: number;
    public name: string;
    public city: City[];

  }  